import {Component} from '@combos-fun/engine';
import {Field} from '@combos-fun/inspector-decorator';

export interface RenderParams {
  alpha?: number;
  zIndex?: number;
  visible?: boolean;
  sortableChildren?: boolean;
}

export default class Render extends Component<RenderParams> {
  static componentName: string = 'Render';
  sortDirty: boolean = false;

  @Field({
    type: 'boolean',
    group: 'Render',
    label: 'Visible',
    description: 'Whether this object is drawn.',
    editor: 'toggle',
  })
  visible: boolean = true;

  @Field({
    type: 'number',
    min: 0,
    max: 1,
    step: 0.01,
    group: 'Render',
    label: 'Opacity',
    description: 'Opacity from 0 (invisible) to 1 (fully opaque).',
    editor: 'number-slider',
  })
  alpha: number = 1;

  @Field({
    type: 'number',
    step: 1,
    group: 'Render',
    label: 'Z-index',
    description: 'Draw order; higher values render on top.',
    editor: 'number-stepper',
  })
  zIndex: number = 0;

  @Field({
    type: 'boolean',
    group: 'Render',
    label: 'Sort children',
    description: 'When on, children are sorted by their z-index before drawing.',
    editor: 'toggle',
  })
  sortableChildren: boolean = false;

  init(obj?: RenderParams) {
    obj && Object.assign(this, obj);
  }
}
